import { RegionCode } from '@ca/common'
import { colors } from '@ui/colors'
import { LogoProps } from './types'

import de_basic from './logos/basic/de'
import es_basic from './logos/basic/es'
import it_basic from './logos/basic/it'
import pl_basic from './logos/basic/pl'
import at_basic from './logos/basic/at'
import kw_basic from './logos/basic/kw'
import tgbo_basic from './logos/basic/tgbo'
import steiner_basic from './logos/basic/steiner'

import de_normal from './logos/motto/de-normal'
import es_normal from './logos/motto/es-normal'
import it_normal from './logos/motto/it-normal'
import pl_normal from './logos/motto/pl-normal'
import at_normal from './logos/motto/at-normal'
import de_tgbo from './logos/motto/de-tgbo'
import es_tgbo from './logos/motto/es-tgbo'
import it_tgbo from './logos/motto/it-tgbo'
import pl_tgbo from './logos/motto/pl-tgbo'
import at_tgbo from './logos/motto/at-tgbo'

import { useAppRegion } from 'storage/useRemoteConfigParams'

type LogoName = RegionCode | 'tgbo' | 'steiner'
type LogoVariant = 'basic' | 'normal' | 'tgbo'

const logos: Record<
  LogoName,
  | React.ComponentType<LogoProps>
  | Record<LogoVariant, React.ComponentType<LogoProps>>
> = {
  de: {
    basic: de_basic,
    normal: de_normal,
    tgbo: de_tgbo,
  },
  es: {
    basic: es_basic,
    normal: es_normal,
    tgbo: es_tgbo,
  },
  it: {
    basic: it_basic,
    normal: it_normal,
    tgbo: it_tgbo,
  },
  pl: {
    basic: pl_basic,
    normal: pl_normal,
    tgbo: pl_tgbo,
  },
  at: {
    basic: at_basic,
    normal: at_normal,
    tgbo: at_tgbo,
  },
  kw: {
    basic: kw_basic,
    normal: kw_basic,
    tgbo: kw_basic,
  },
  tgbo: tgbo_basic,
  steiner: steiner_basic,
} as const

export interface LogoComponentProps extends LogoProps {
  name?: LogoName
  variant?: LogoVariant
}

export default function Logo(props: LogoComponentProps) {
  const appRegion = useAppRegion()

  const region = props.name || appRegion.code
  const variant = props.variant || 'basic'

  let Result

  if (typeof logos[region] === 'object') {
    Result = logos[region][variant]
  } else {
    Result = logos[region]
  }

  if (!Result) return null

  return <Result {...props} color={props.color || colors.white} />
}
